<template>
  <div class="order-detail-page full-height display-col">
    <full-con :canReturn="canReturn">
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <el-form>
          <div class="tabel-container">
            <el-row class="table-content">
              <el-col :span="24" class="content">
                <el-row>
                  <el-col :span="10" class="labelTitle"> <span class="el-icon-document">&nbsp;账单编号：</span></el-col>
                  <el-col :span="14" class="labelValue">{{ paymentInfo.billNo }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" class="labelTitle">批次号：</el-col>
                  <el-col :span="14" class="labelValue">{{ paymentInfo.containerBatchNo }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" class="labelTitle">国际运费：</el-col>
                  <el-col :span="14" class="labelValue">{{ formatNumberWithCommas(paymentInfo.freight) }}元
<!--                    <span style="margin-left: 10px; color: #ff691f;">{{ formatNumberWithCommas(paymentInfo.freightJp) }}円</span>-->
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div class="tabel-container">
            <el-row class="table-content">
              <el-col :span="24" class="content">
                <el-row>
                  <el-col :span="10" class="labelTitle">商品与检品费：</el-col>
                  <el-col :span="14" class="labelValue">{{ formatNumberWithCommas(paymentInfo.batchOrderAmountAll) }}元</el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" class="labelTitle">合计：</el-col>
                  <el-col :span="14" class="labelValue">{{ formatNumberWithCommas(paymentInfo.total) }}元</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <br />
        </el-form>
        <div class="title">
          <div class="strong">国际运费：</div>
          <div>付款时间：{{ paymentInfo.payTime | dateFormatToMin }}</div>
        </div>
        <el-table class="qqq" show-summary :summary-method="getSummaries" :data="paymentInfo.freightList" border stripe
          style="width: 100%" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
          <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
          <el-table-column prop="payName" label="项目" align="center"></el-table-column>
          <el-table-column prop="count" label="数量" align="center"></el-table-column>
          <el-table-column prop="price" label="单价" align="center"></el-table-column>
          <el-table-column prop="discountAmount" label="优惠/折扣" align="center"></el-table-column>
          <el-table-column prop="receivedAmount" label="总金额" align="center"></el-table-column>
          <el-table-column prop="receivedAmountJp" label="总金额(円)" align="center"></el-table-column>
        </el-table>
        <div class="title">
          <div class="strong">商品与检品费：</div>
        </div>
        <el-table show-summary :summary-method="getSummaries1" :data="paymentInfo.goodsList" border stripe
          style="width: 100%" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
          <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
          <el-table-column prop="goodsName" label="品名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
          <el-table-column prop="pictureUrl" label="商品URL" align="center">
            <template v-slot="scope">
              <img v-if="scope.row.pictureUrl" :src="scope.row.pictureUrl" alt="">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" align="center"></el-table-column>
          <el-table-column prop="goodsCount" label="数量" align="center"></el-table-column>
          <el-table-column prop="boxCount" label="装箱数量" align="center"></el-table-column>
          <el-table-column prop="goodsAmount" label="商品费" align="center"></el-table-column>
          <el-table-column prop="boxGoodsAmount" width="120px" label="装箱商品费用" align="center"></el-table-column>
          <el-table-column prop="orderAgentServiceFee" label="代购手续费" align="center"></el-table-column>
          <el-table-column prop="orderInlandFreight" label="中国运费" align="center"></el-table-column>
          <el-table-column prop="orderProblemHandlingFee" label="异常处理费" align="center"></el-table-column>
          <el-table-column prop="orderReturnFee" label="退货运费" align="center"></el-table-column>
          <el-table-column prop="configCheckProjectPrice" label="检品费" width="250" align="left">
            <template v-slot="scope">
              <div v-for="(item, index) in scope.row.configCheckProject" :key="index">
                {{ item.checkName }}： {{ item.price }}
              </div>
              换回详细检品费： {{ scope.row.exchangeInspectionFee }}
            </template>
          </el-table-column>
          <el-table-column prop="orderLabelFee" label="标签费" align="center"></el-table-column>
          <el-table-column prop="orderCategoryPrice" label="仓库保管费" align="center"></el-table-column>
          <el-table-column prop="batchOrderAmount" label="总费用" align="center"></el-table-column>
        </el-table>
        <div style="margin-top:15px">※装箱单商品一览表。</div>
        <div>※这些费用会在订单处理过程中自动扣除。</div>
        <div>※仓库保管费在批次发送时才自动扣除。</div>
        <div>※不包含个别信息中有追加发送委托的项目。</div>
      </div>
    </full-con>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canReturn: '1',
      pageTitle: '账单',
      containerBatchNo: '',
      list: [1, 1, 1, 1, 1],
      isEditPage: 0,
      configPayProject: {},
      paymentInfo: {},
      paymentItemList: [],
      payBtn: true,
      payFail: false,
    }
  },
  methods: {
    formatNumberWithCommas(num){
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          sums[index] = '';
          return
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2)
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
        if (column.label.indexOf('円') > -1) {
          sums[index] = sums[index].replace(' 元', '');
          sums[index] = Math.ceil(sums[index]);
          sums[index] += ' 円';
        }
      });

      return sums;
    },
    handleExport() {
      let data = {
        containerBatchNo: this.containerBatchNo,
      }
      this.$http({
        url: "container/exportObtainFBAOrder",
        method: 'post',
        data,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `账单.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch(() => {
      })
    },
    getSummaries1(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6) {
          sums[index] = '';
          return;
        }
        if (index === 11) {
          const values1 = data.map(item => Number(item['configCheckProjectPrice']));
          sums[11] = values1.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2)
          sums[index] += ' 元';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2)
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    //获取收费项目
    async getConfigPayProject() {
      const { data: res } = await this.$http.get('configPayProject/getAllConfigPayProject');
      this.configPayProject = res.data;
    },//获取账单信息
    async getOrderBill() {
      const { data: res } = await this.$http.post('container/getObtainFBAOrder', { "containerBatchNo": this.containerBatchNo });
      this.paymentInfo = res.data;
      console.log(res.data)
      this.paymentItemList = this.paymentInfo.list;
    },
    async savePost() {
      const { data: res } = await this.$http.post('order/payment/pay', { id: this.paymentInfo.id });
      if (res.code == 200) {
        this.$message.success(res.message);
        this.$router.go(-1);
      }
      else {
        //余额不足
        if (res.code == 1000) {
          this.payBtn = false;
          this.payFail = true;
        } else {
          this.$message.error(res.message);
        }
      }
    },//金额格式
    priceShow(row, column, cellValue, index) {
      let ret = ''
      ret = cellValue + '元'
      return ret
    },//收费项目格式
    payProjectFormat(row, column, cellValue, index) {
      if (this.configPayProject.length > 0) {
        let payProject = this.configPayProject.filter(function (item) {
          return item.value == cellValue;
        });

        let payProjectName = '';
        if (payProject && payProject.length > 0) {
          payProjectName = payProject[0].name
        }

        return payProjectName;
      }

    },//支付账单
  },
  created() {
    this.containerBatchNo = this.$route.query.containerBatchNo;
    this.isEditPage = this.$route.query.isEdit;
    this.getConfigPayProject();
    this.getOrderBill();
  }
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;

  .strong {
    font-weight: bold;
    font-size: 20px;
  }
}

.order-detail-container {
  background: #fff;
  padding: 20px;
}

ul,
li {
  list-style: none;
}

.labelTitle {
  text-align: left;
}

.labelValue {
  text-align: right;
}

.table-title {
  padding: 5px 0;
  text-align: center;
  background: #f1f2f6;
}

.table-content .content .el-col {
  height: 35px;
  line-height: 30px;
  padding: 0 2px;
  border-bottom: 1px solid #e5e9f8;
  // white-space:nowrap;
  // text-overflow:ellipsis;
  overflow: auto;
}

.el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-form-item__content {
  line-height: 30px !important;
}

/deep/ .el-icon-document {
  font-size: 17px;
}

.amountShow {}

.amountShow span {
  display: block;
  color: red;
}

.amountShow .span1 {
  text-decoration: line-through;
  color: #333333;
  text-decoration-color: red;
}

.qqq {
  ::v-deep .el-table__footer-wrapper {
    tbody {
      td:last-child{
        color: #ff691f;
      }
    }
  }
}

// .table-content .content{
//   padding-bottom: 10px;
// }</style>
